import AppPopup from '@/components/popups/app-popup';

export default  {
    methods: {
        showPopup(props, type) {
            this.$modal.show(
                AppPopup,
                {
                    type,
                    ...props,
                },
                {
                    height: this.$helpers.setPopupHeight(),
                    width: this.$helpers.setPopupWidth(),
                }
            );
        },

    }
}
